import { render, staticRenderFns } from "./ModalHistoricoAditivoApostila.vue?vue&type=template&id=02171a1c"
import script from "./ModalHistoricoAditivoApostila.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoAditivoApostila.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoAditivoApostila.vue?vue&type=style&index=0&id=02171a1c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports